import { dataTrack as originTrace } from '@nio-fe/challenger-data-track';
import { nioJsBridge } from '@nio-wad/universal-bridge-h5'
import { useFeatureListStore, useGlobalStore } from 'shared'
import { getFellowName, isTpad,getNioBindedUserInfo ,getShopInfo} from './toolBridge';
import { getQueryString } from "./index";


export const trackPageNameMap = {
  'exterior_custom':'外观定制',
  'cockpit_custom':'座舱定制',
  'designer_color':'设计师方案'
}

export enum TraceOptionConfigType {
  VersionBattery = 'version_battery',
  Exterior = 'exterior',
  Cockpit = 'cockpit',
  Optional = 'optional',
  All = 'all',
  None = 'none',
}
export const traceOptionConfigList = [
  TraceOptionConfigType.VersionBattery,
  TraceOptionConfigType.Exterior,
  TraceOptionConfigType.Cockpit,
  TraceOptionConfigType.Optional,
]

export const getCurrentConfig = (configType: TraceOptionConfigType = TraceOptionConfigType.All) => {
  const globalStore:any = useGlobalStore()
  const featureListStore:any = useFeatureListStore()  
  const getOption = (optionCode) => {
    if (typeof optionCode === 'string') {
      return featureListStore.data?.option_map?.[optionCode]
    }
    return optionCode
      ? (Object.values(optionCode)
        .map((code) => featureListStore.data?.option_map?.[code])
        .filter((item) => !!item))
      : ({} as any)
  }
  const versionBatteryConfig = {
    battery: getOption(globalStore.currentOptions.F00019)?.name ?? '',
    battery_plan: getOption(globalStore.currentOptions.F00029)?.name ?? '',
  }
  const exteriorConfig = {
    color: getOption(globalStore.currentOptions.F00002)?.name ?? '',
    rim: getOption(globalStore.currentOptions.F00003)?.name ?? '',
    exterior_custom:
      getOption(globalStore.currentOptions.exteriorCustom)
        ?.map((item) => item.name)
        ?.join(',') ?? '',
  }
  const cockpitConfig = {
    cockpit_interior_color:
      getOption(globalStore.currentOptions.F00004)?.name ?? '',
    cockpit_interior_material:
      getOption(globalStore.currentOptions.F00024)?.name ?? '',
    carkey: getOption(globalStore.currentOptions.F00020)?.name ?? '',
    cockpit_interior_custom:
      getOption(globalStore.currentOptions.interiorCustom)
        ?.map((item) => item?.name)
        ?.join(',') ?? '',
  }

  const optionalConfig = {
    option:
      getOption(globalStore.currentOptions.optionalConfig)
        ?.map((item) => item?.name)
        ?.join(',') ?? '',
  }

  let allConfig = {}
  if (configType == TraceOptionConfigType.VersionBattery) {
    allConfig = { ...allConfig, ...versionBatteryConfig }
  }
  if (configType == TraceOptionConfigType.Exterior) {
    allConfig = { ...allConfig, ...exteriorConfig }
  }
  if (configType == TraceOptionConfigType.Cockpit) {
    allConfig = { ...allConfig, ...cockpitConfig }
  }
  if (configType == TraceOptionConfigType.Optional) {
    allConfig = { ...allConfig, ...optionalConfig }
  }
  if (configType == TraceOptionConfigType.All) {
    allConfig = {
      car_model: globalStore.currentOptions.model_code || '',
      car_type: globalStore.currentOptions.generation_code || '',
      mode: globalStore.currentMode == '3D' ? '3D模式' : '极速模式',
      ...allConfig,
      ...versionBatteryConfig,
      ...exteriorConfig,
      ...cockpitConfig,
      ...optionalConfig,
    }
  }
  return  allConfig ?? {}
}
export const getPageNameTrack = (rightBtnType) => {
  const globalStore:any = useGlobalStore()
  switch (rightBtnType) {
    case "carList":
      return '车型选择页'
    case "config":
      return  globalStore.getCurrentWebPageName
    case "quote":
      return "报价过程页";
    case "completion":
      return "报价结果页";
    default:
      return "车型选择页";
  }
}
export const traceEventClick = (
  params,
  evtName = '',
  withAllConfig = false
) => {
  const commonParams: any = {
    track_sign:'agouche.b2976.click.PadCarPartsSelectionClick',
    mp_name:'定制爱车',
    mp_id:'configurator-website-3D',
    requirement_id:1208
  }
  params = {
    ...commonParams,
    ...params
  }
  evtName = evtName || 'PadCarPartsSelectionClick'
  traceEvent(params,evtName,withAllConfig)
}

// 获取fl的归属门店
/**
 * niohouse_id
 * niohouse_name
 * niohouse_city
 * niohouse_district
 */
export const getFlShopInfo = ()=>{
  if(!isTpad) return {}
  let shopInfo = getShopInfo();
  let niohouse_id = '',niohouse_name='',niohouse_city='',niohouse_district='';
  shopInfo&&shopInfo.forEach(item => {
     niohouse_id = niohouse_id+`${item?.nio_house_id||''},`;
     niohouse_name =niohouse_name+`${item?.nio_house_name||''},`;
     niohouse_city = niohouse_city+`${item?.nio_house_city||''},`;
     niohouse_district = niohouse_district +`${item?.nio_house_district||''},` 
  });
  return {
    niohouse_id,
    niohouse_name,
    niohouse_city,
    niohouse_district
  }
}

export const tracePlatformParams = () => {
  const params:any = {}
  if (isTpad) {
    const fellow_name =  getFellowName()
    params.fellow_name = fellow_name || ''
    params.platform_type = 'ipad'
  }else{
    params.platform_type = 'pc'
  }
  return params
}

export const traceEvent = async (
  params,
  evtName?: string,
  withAllConfig = false //是否上报配置
) => {
  const page_source = getQueryString("page_source", window.location) || "";

  const accountId = getNioBindedUserInfo()?.account_id;
  const shopInfo = getFlShopInfo()
  console.log('track shoInfo>>>>>>>>>>>>>>>>>>>',shopInfo)

  const commonParams: any = tracePlatformParams()
  const requirement_id = 865
  const allConfig = withAllConfig ? getCurrentConfig() : {}

  originTrace(evtName, {
    requirement_id,
    page_source:page_source || '',
    user_account:accountId||'',
    ...shopInfo,
    ...allConfig,
    ...commonParams,
    ...params
  })
}

export const traceExpo = (params) => {
  const globalStore:any = useGlobalStore()
  const configParams = getCurrentConfig();
  const commonParams = tracePlatformParams()
  const baseParams = {
    requirement_id:1168,
    track_sign: "agouche.b2976.exposure.PadCarPartselectionExpo",
    page:globalStore.getCurrentWebPageName,
  }
  try {
    return JSON.stringify({
      ...configParams,
      ...commonParams,
      ...baseParams,
      ...params,
    });
  } catch (error) {
    console.log(error);
    return "{}";
  }


}


export const disAppearTrace = ()=>{
  console.log('---注册销毁事件--->>>');
//   dsBridge.register('ON_DISAPPEAR',function(l){
//     alert("ON_DISAPPEAR：" + JSON.stringify(l))
//  })
  nioJsBridge.register({
    event: 'ON_DISAPPEAR',
    data: {
      preventDefault: 0,
    },
    callback: (e) => {
      console.log('-收到销毁事件--e---', e)
      const globalStore:any = useGlobalStore()
      const page = globalStore.getCurrentWebPageName || ''
      traceEvent({
        page,
        page_source:'',
        track_sign: 'agouche.b2976.pageview.PadCarPartSelectionPageShut',
        car_model: globalStore.currentOptions.model_code || '',
        car_type: globalStore.currentOptions.generation_code || '',
        shut_type:''
      },'PadCarPartSelectionPageShut')
    },
  })
}
